module.exports = __webpack_public_path__ + "img/money_pop.550d749e.png";